module.exports = __webpack_public_path__ + "img/asli-logo-giris.d79ab060.jpg";